import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class Fiend extends UnitType {
    readonly id = "fiend";
    readonly displayName = "Fiend";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.netherworld; }
    canEnter(ctx: PlaceContext) { return !ctx.world.hasNearbyObj(ctx.x, ctx.y, 5, "shrine") && this.inTile(ctx, ["land", "tree", "ocean"]); }
    description() { return "can fly.\ndefeats other fiends."; }
    defeats() { return ["fiend"]; }
    cost() { return { blood: 50, souls: 1, runes: 0 }; }
    img(ctx: UnitContext) { return "fiend_" + ctx.faction; }
    maxCooldown() { return 3000; }
    moveRange() { return 4.5; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "fiend"); }
    step(ctx: ObjContext) {
        if (ctx.faction !== "player") {
            this.hunt(ctx, c => {
                const obj = c.world.get(c.x, c.y);
                if (obj) {
                    if (this.canDefeat(obj.unitId)) return 3;
                    if (this.canHuntStaticObjectiveNear(ctx, c.x, c.y)) return 2;
                }
                return 0;
            });
        }
    }
    influenceRange(): number { return 1.5; }

}
